module.exports = __webpack_public_path__ + "img/settingWidget.a747e5f4.png";